export const NAME = 'coupon';

export const REQUEST_COUPONS = 'REQUEST_COUPONS';
export const RECEIVE_COUPONS = 'RECEIVE_COUPONS';
export const FAILURE_COUPONS = 'FAILURE_COUPONS';



// WEBPACK FOOTER //
// ./src/services/coupon/constants.js